// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import ArrowBackward, { ArrowBackwardOffset } from "@store/Library/Components/Toolkit/Icons/ArrowBackward";
import ChevronRight from "@store/Library/Components/Toolkit/Icons/ChevronRight";
import { menuPanelRowStyles } from "@store/Themes/common/mixins/menu";
import { buttonResetProps } from "@store/Themes/common/props/button";
import { menuPanelProps } from "@store/Themes/common/props/menu";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const panelMenu: Styleguide["panelMenu"] = {
    defaultProps: {
        cssOverrides: {
            children: menuPanelProps.wrapperCss,
            menu: menuPanelProps.menuCss,
        },
        closeButtonPanelRowProps: {
            css: menuPanelProps.headerCss,
        },
        closeButtonProps: menuPanelProps.closeButton,
        closeIconProps: menuPanelProps.closeButtonIcon,
        parentPanelRowProps: {
            css: css`
                ${menuPanelRowStyles({
                    iconPosition: "right",
                    color: "inherit",
                    hoverColor: "inherit",
                    hoverUnderline: false,
                })}
            `,
        },
        parentLinkProps: {
            css: css`
                ${menuPanelRowStyles({
                    iconPosition: "right",
                    color: "menu.mainNavigation.accent",
                    hoverColor: "menu.mainNavigation.accentHover",
                    borderColor: "transparent",
                })}

                width: auto;
                padding: 0;
                white-space: nowrap;
            `,
        },
        parentTypographyProps: {
            ellipsis: true,
            css: css`
                /* Store removed - text-transform */
                /* Store Custom Code - Start */
                font-weight: ${x => x.theme.design.typography.weight.bold};
                color: ${getColor("menu.mainNavigation.accent")}; /* Store Custom Code */
                /* Store Custom Code - End */
            `,
        },
        backButtonProps: {
            ...buttonResetProps,
            css: css`
                ${buttonResetProps.css}
                ${menuPanelRowStyles({
                    borderColor: "transparent",
                    color: "menu.mainNavigation.accent",
                    hoverColor: "menu.mainNavigation.accentHover",
                    iconOffset: ArrowBackwardOffset,
                })}
                display: flex;
                align-items: center;
                width: 100%;
                text-align: left;
                font-weight: ${x => x.theme.design.typography.weight.bold};
                padding-top: 0;
                padding-bottom: 0;
            `,
        },
        backTitleTypographyProps: { ellipsis: true },
        backIconProps: { src: ArrowBackward },
        bodyColor: "transparent",
        panelRowProps: {
            css: css`
                ${menuPanelRowStyles(
                    {
                        color: "menu.mainNavigation",
                        hoverColor: "menu.mainNavigation",
                        iconPosition: "right",
                        borderColor: "menu.mainNavigation.separator",
                    } /* Store Custom Code */,
                )}
            `,
            isCurrentCss: css`
                background-color: transparent;
                text-decoration: underline;
                color: ${getColor("menu.mainNavigation.accent")}; /* Store Custom Code */
            `,
            moreIconProps: { src: ChevronRight },
        },
        childTypographyProps: {
            size: "inherit",
            weight: "initial",
        },
    },
};

export default panelMenu;
